import { Form, FormProps, Modal, ModalProps ,Input, Select} from "@pankod/refine-antd";
import { useGetIdentity } from "@pankod/refine-core";
import { useEffect, useState } from "react";
import { getAllRoles } from "users";

type CreateConfigProps = {
    modalProps: ModalProps;
    formProps: FormProps;
  };
  export const CreateConfig: React.FC<CreateConfigProps> = ({
    modalProps,
    formProps,
  }) => {
    const { data: user } = useGetIdentity()
    const [roleList, setRoleList] = useState([] as any[])
    useEffect(() => {
        getAllRoles().then((response: any) => {
          setRoleList(response.authRoles)
        })
      }, [])
    return(
        <Modal
      {...modalProps}
      title="Create Configuration"
      okButtonProps={{
        // hidden: error,
        onClick: formProps?.form?.submit,
      }}
    >
      <Form {...formProps} size="large" layout="vertical" >
      
        <Form.Item
          label="User Types"
          name="user_types"
          rules={[
            {
              required: true,
            },
          ]}
        >
        <Select
             
             mode="multiple"
              size="large"
              style={{ width: '100%' }}
            >
              {roleList?.length > 0 &&
                roleList?.map(
                  item =>
                    item?.role !== 'user' &&
                    item?.role !== 'me' && (
                      <option key={item?.role} value={item?.role}>
                        {item?.role}
                      </option>
                    )
                )}
            </Select>
        </Form.Item>
        <Form.Item
          label="Period"
          name="period_days"
          rules={[
            {
              required: true,
            },
          ]}
        >
         <Select
    //   defaultValue='1 month'
      style={{ width: '100%' }}
      options={[
        { value: 7, label: '7 Days' },
        { value: 15, label: '15 Days' },
        { value: 30, label: '1 month' },
        { value: 90, label: 'Quarterly', },
        { value: 182, label: 'Half-yearly', },
        { value: 365, label: 'Yearly', },
      ]}
    />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
        {/* {error ? <Typography.Text type="danger">Duplicate Found..Please enter another order</Typography.Text> : null} */}
      </Form>
    </Modal>
    )
}
export default CreateConfig